import { Icon, SvgVolume1, SvgVolume2, SvgVolumeX } from '@loomhq/lens';
import React from 'react';

import ControlBarButton from '../../control-bar-button';

export default function FullscreenButton(props) {
  const hoverTagText = props.muted ? 'Unmute (m)' : 'Mute (m)';

  return (
    <ControlBarButton
      className="video-player-volume-button"
      hoverTagText={hoverTagText}
      seeking={props.seeking}
      onClick={props.onButtonClick}
    >
      {(props.muted || props.volume === 0) && (
        <Icon color="white" icon={<SvgVolumeX />} />
      )}
      {props.volume <= 0.5 && !props.muted && (
        <Icon color="white" icon={<SvgVolume1 />} />
      )}
      {props.volume > 0.5 && !props.muted && (
        <Icon color="white" icon={<SvgVolume2 />} />
      )}
    </ControlBarButton>
  );
}
